import axios from 'axios'
import Session from 'supertokens-auth-react/recipe/session'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACK_API_URL || 'https://supplier.peppermint.company/api/',
})
Session.addAxiosInterceptors(axiosInstance)

export default axiosInstance
